var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-box" },
    [
      _c(
        "el-form",
        {
          attrs: {
            data: _vm.tripInfo,
            inline: false,
            size: "small",
            "label-width": "88",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "上车站点：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.getOnStation)),
                  ]),
                  _c("el-form-item", { attrs: { label: "预定座位：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.reservedSeats)),
                  ]),
                  _c("el-form-item", { attrs: { label: "出发时间：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.departureDateTime)),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "下车站点：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.getOffStation)),
                  ]),
                  _c("el-form-item", { attrs: { label: "实际座位：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.actualSeats)),
                  ]),
                  _vm.isDoorToDoor
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "乘客端展示时间(门对门模式)：" } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.timeStr) + "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("el-form-item", { attrs: { label: "公里数：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.mileage)),
                  ]),
                  _c("el-form-item", { attrs: { label: "预计时长：" } }, [
                    _vm._v(_vm._s(_vm.tripInfo.expectedTime)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }